module.exports = __webpack_public_path__ + "media/images/landing/icon-core-benefits-0999fde3127c192c55eeb003c4479eac.svg";